import { Outlet } from "react-router-dom";
import BottomTabs from "@/components/BottomTabs";
import { useAuth } from "@/contexts/AuthContext";

/**
 * AppShell wraps the tabbed app (Home / History / Settings).
 * Guest users (not authenticated) can still use the app — Home tab works with a
 * 3/day limit via the anonymous session flow. History and Settings show a
 * "create account" prompt when accessed as a guest (handled inside each page).
 */
export default function AppShell() {
  const { isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F9FB]">
        <div className="w-8 h-8 rounded-full border-2 border-[#E5E7EB] border-t-[#2F5BFF] animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F7F9FB]" data-testid="app-shell">
      <main className="pb-20">
        <Outlet />
      </main>
      <BottomTabs />
    </div>
  );
}
